//cookie的失效时间
export const EXPIRES = 1
//cookie的全局设置
export const COOKIE_EXT = {
    expires: EXPIRES
}
